import { type Ref, watch } from 'vue'

export function useScrollLock(trigger: Ref<boolean>) {
  watch(
    trigger,
    (isOpen) => {
      const body = document.body
      const hasClass = body.classList.contains('overflow-hidden')

      if (isOpen && !hasClass) {
        body.classList.add('overflow-hidden')
      } else if (!isOpen && hasClass) {
        body.classList.remove('overflow-hidden')
      }
    },
    { immediate: true },
  )
}
